import { render, staticRenderFns } from "./CarriersModal.vue?vue&type=template&id=dabe8036&scoped=true"
import script from "./CarriersModal.vue?vue&type=script&lang=js"
export * from "./CarriersModal.vue?vue&type=script&lang=js"
import style0 from "./CarriersModal.vue?vue&type=style&index=0&id=dabe8036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabe8036",
  null
  
)

export default component.exports